class VariantPills extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        const containers = this.querySelectorAll('.variant-selection');
        containers.forEach(container => {
            const pills = container.querySelectorAll('.variant-pill');
            const variantInput = container.querySelector('.product-variant-id');
            const addToCartButton = container.querySelector('button[type="submit"]');
            if (addToCartButton && (!variantInput || !variantInput.value)) {
                addToCartButton.disabled = true;
            }

            pills.forEach(pill => {
                pill.addEventListener('click', () => {
                    if (pill.disabled) return;
                    pills.forEach(p => p.classList.remove('selected'));
                    pill.classList.add('selected');
                    if (variantInput) {
                        variantInput.value = pill.dataset.variantId;
                        variantInput.disabled = false;
                        if (addToCartButton) {
                            addToCartButton.disabled = false;
                        }
                    }
                    const changeEvent = new Event('change', { bubbles: true });
                    container.dispatchEvent(changeEvent);
                    if (pill.parentNode.nextElementSibling) {
                        pill.parentNode.nextElementSibling.style.display = "block";
                    }
                });
            });
            const firstAvailablePill = Array.from(pills).find(pill => !pill.disabled);
            if (firstAvailablePill && !container.querySelector('.variant-pill.selected')) {
                firstAvailablePill.click();
            }
        });
    }
}
customElements.define('custom-variant-selection', VariantPills);
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('custom-variant-selection').forEach(el => {
        new VariantPills();
    });
});
